import { DialogElement } from '../dialog';
import { foundationModalStyles as styles } from './modal.styles';
import { foundationModalTemplate as template } from './modal.template';
// explicitly declaring for extensibility
export const foundationModalShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
export const defaultModalConfig = {};
/**
 * @tagname %%prefix%%-modal
 */
export class Modal extends DialogElement {
    show() {
        if (this.onShowCallback)
            this.onShowCallback();
        this.mainElement['showModal']();
    }
}
/**
 * The Foundation Modal
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-modal\>
 */
export const foundationModal = Modal.compose(Object.assign({ baseName: 'modal', styles,
    template, shadowOptions: foundationModalShadowOptions }, defaultModalConfig));
